var HtmlAttributes = /** @class */ (function () {
    function HtmlAttributes() {
    }
    // Used by content editor to load Tile configuration by id
    HtmlAttributes.blockType = "data-editorblocktype";
    HtmlAttributes.dataLayout = "data-layout";
    HtmlAttributes.dataSectionAttrName = "data-section";
    HtmlAttributes.classAttrName = "class";
    // FormFields html attributes
    HtmlAttributes.targetAudience = "data-targetaudience";
    HtmlAttributes.targetProperty = "data-targetproperty";
    HtmlAttributes.savedFieldId = "data-savedfieldid";
    HtmlAttributes.hide = "data-hide";
    HtmlAttributes.dataRequired = "data-required";
    HtmlAttributes.dataReadOnly = "data-readonly";
    HtmlAttributes.dataRequiredForCancel = "data-requiredForCancel";
    HtmlAttributes.dataCountryCode = "data-countrycode";
    HtmlAttributes.prefill = "data-prefill";
    HtmlAttributes.title = "title";
    HtmlAttributes.value = "value";
    // FormFields html attribute values
    HtmlAttributes.requiredValue = "required";
    HtmlAttributes.readonlyValue = "readonly";
    HtmlAttributes.pattern = "pattern";
    HtmlAttributes.min = "min";
    HtmlAttributes.max = "max";
    HtmlAttributes.maxLength = "maxlength";
    HtmlAttributes.type = "type";
    // TwoOption field html attributes
    HtmlAttributes.optionsValues = "data-options";
    // Lookup field html attributes
    HtmlAttributes.publicVisibility = "data-publicvisibility";
    HtmlAttributes.lookupTargets = "data-lookuptargets";
    HtmlAttributes.lookupParentChildEntity = "data-parent-child-entity-logicalname";
    HtmlAttributes.lookupParentChildRelationship = "data-parent-child-to-parent";
    HtmlAttributes.lookupParentFieldId = "data-parent-fieldid";
    // Label elements on canvas
    HtmlAttributes.nonfocusableFor = "data-for";
    HtmlAttributes.forAttribute = "for";
    HtmlAttributes.editorWrapperSelector = "[contenteditable]";
    // Form/placeholder attributes
    HtmlAttributes.successMessage = "data-successmessage";
    HtmlAttributes.waitlistMessage = "data-waitlistmessage";
    HtmlAttributes.errorMessage = "data-errormessage"; // also used for validation
    HtmlAttributes.notStartedMessage = "data-notstartedmessage";
    HtmlAttributes.closedMessage = "data-closedmessage";
    HtmlAttributes.redirectUrl = "data-redirecturl";
    HtmlAttributes.unboundForm = "data-unboundform";
    HtmlAttributes.preventSubmissionUi = "data-preventsubmissionui";
    HtmlAttributes.feedbackPosition = "data-feedback-position";
    // Form validation
    HtmlAttributes.validateSubmission = "data-validate-submission";
    // Event/Sessions attributes
    HtmlAttributes.dataAvailableSeats = "data-availableseats";
    HtmlAttributes.dataWaitlistEnabled = "data-waitlistenabled";
    HtmlAttributes.dataEventSubmissionType = "data-eventsubmissiontype";
    // ReCaptcha attributes
    HtmlAttributes.reCaptchaDataSiteKey = "data-sitekey";
    HtmlAttributes.reCaptchaErrorText = "recaptcha-error-text";
    HtmlAttributes.gRecaptcha = "g-recaptcha";
    HtmlAttributes.gRecaptchaResponse = "g-recaptcha-response";
    HtmlAttributes.reCaptchaV2SiteKeyHolder = "recaptchav2-sitekey-holder";
    HtmlAttributes.reCaptchaV2ImageHolder = "recaptchav2-image-holder";
    return HtmlAttributes;
}());
export { HtmlAttributes };
